const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const normalizeEmail = (value: unknown) => String(value ?? "").trim().toLowerCase()

export const isValidEmail = (value: unknown) => EMAIL_PATTERN.test(normalizeEmail(value))
